import { useEffect } from 'react';
import { useSelector, useDispatch } from 'react-redux';
import { useParams, useLocation } from 'react-router-dom';
import ReviewCreate from '../components/ReviewsCreate';
import { fetchPage } from '../../../routes/actions';
import {
  stageNewReview,
  correctReview,
  submitGuestReview,
} from '../../../features/reviews/actions';
import { REVIEWS_NEW } from '../../../routes/config/pageTypes';

export default function ReviewCreateContainer() {
  const { lang, invitationCode } = useParams();
  const location = useLocation();
  const dispatch = useDispatch();
  const reviews = useSelector((state) => state.reviews);

  useEffect(() => {
    dispatch(fetchPage(lang, REVIEWS_NEW, { lang, invitationCode }, location));
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [lang, invitationCode]);

  return (
    <ReviewCreate
      {...reviews}
      lang={lang}
      onDoStaging={(ratings, reviewText, npsScore) =>
        dispatch(stageNewReview(ratings, reviewText, npsScore))
      }
      onCorrectReview={() => dispatch(correctReview())}
      handleReviewSubmit={(lang, invitationCode, ratings, reviewText, npsScore) =>
        dispatch(submitGuestReview(lang, invitationCode, ratings, reviewText, npsScore))
      }
    />
  );
}
